(function () {
  function getPreferredCurrency() {
    try { return localStorage.getItem("preferred_currency") || ""; }
    catch (e) { return ""; }
  }

  function canConvert() {
    return window.Currency && typeof window.Currency.convert === "function" && window.Currency.rates;
  }

  // Convert from USD cents -> preferred currency formatted text using Currency.js
  function formatPreferredFromUsdCents(usdCents, preferred) {
  if (!preferred || !canConvert()) return null;

  var usd = (usdCents / 100);
  var converted = window.Currency.convert(usd, "USD", preferred);

  if (typeof window.Currency.formatMoney === "function") {

    var fmt =
      (window.Currency.moneyFormats && window.Currency.moneyFormats[preferred]) ||
      (window.Currency.moneyFormats && window.Currency.moneyFormats["USD"]) ||
      (window.theme && window.theme.moneyFormat) ||
      "${{amount}}";

    if (fmt && typeof fmt === "object") {
      fmt = fmt.money_format || fmt.format || fmt.moneyFormat || "${{amount}}";
    }

    if (typeof fmt !== "string") {
      fmt = String(fmt || "${{amount}}");
    }

    return window.Currency.formatMoney(Math.round(converted * 100), fmt);
  }

  return converted.toFixed(2) + " " + preferred;
}

  // USD formatting using Shopify.formatMoney if available
  function formatUsd(usdCents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(usdCents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "${{amount}}");
    }
    // fallback
    return "USD $" + (usdCents / 100).toFixed(2);
  }

  function injectDualPrices(scope) {
    var preferred = getPreferredCurrency();
    if (!preferred) return;

    // Any element with data-usd-cents will get a 2-line price
    var nodes = (scope || document).querySelectorAll("[data-usd-cents]");
    nodes.forEach(function (el) {
      var usdCents = parseInt(el.getAttribute("data-usd-cents"), 10);
      if (isNaN(usdCents)) return;

      var preferredText = formatPreferredFromUsdCents(usdCents, preferred);
      var usdText = formatUsd(usdCents);

      // Build or reuse wrapper
      var wrap = el.querySelector(".dual-price");
      if (!wrap) {
        wrap = document.createElement("div");
        wrap.className = "dual-price";
        el.appendChild(wrap);
      }

      wrap.innerHTML =
  '<div class="dual-price__usd">' + usdText + "</div>";
    });
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", function () {
  // Do not inject on product page, because product page already uses .money + usd-ref-line
  if (document.body.classList.contains("template-product")) return;

  injectDualPrices(document);
});

  // If your mini cart re-renders via JS, call this after render
  window.injectDualPrices = injectDualPrices;
})();
